const flatpickrInit = () => {
  // @ts-ignore
  flatpickr('.fpicker', {
    "locale": "ja",
    dateFormat: 'Y.m.d'
  });
}

export default flatpickrInit;